import { Stack } from "@mui/material";
import { Text } from "@flat-ui";
import { ListItemCardMobile } from "@components/common/mobile/list-item-card-mobile";
import { SdbMemberTypes } from "@custom-types/member-types";
import { MemberTableSubject } from "@components/common/faro-table/faro-table-types";
import { generateMemberProfileRoute } from "@router/router-helper";
import { RoleColumn } from "@components/table/members/members-column/role-column/role-column";
import { UserAvatarWithMenu } from "@components/user-more-info-menu/user-avatar-with-menu";
import { MemberStatus } from "@components/table/members/members-column/status-column/member-status";
import { withEllipsis } from "@styles/common-styles";
import { MenuItemOption } from "@components/common/mobile/mobile-types";
import { SphereDivider } from "@components/common/sphere-divider";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { SdbProject } from "@custom-types/project-types";

interface Props {
  /** The member to render */
  member: SdbMemberTypes;

  /** Index of the member in the list */
  index: number;

  /** Company ID for generating routes and role column */
  companyId: string;

  /** Table subject type for role column */
  tableSubject: MemberTableSubject;

  /** Menu items for the member */
  menuItems: MenuItemOption<SdbMemberTypes>[];

  /** The selected group if there is one */
  group?: FaroCoreApiTypes.GroupDetailResponse | null;

  /** The selected project if there is one */
  selectedProject?: SdbProject | null;
}

/**
 * Renders a single member item in the mobile members list view.
 * Displays member avatar, email, role, name/status, and menu options.
 */
export function MembersMobileViewItem({
  member,
  index,
  companyId,
  tableSubject,
  menuItems,
  group,
  selectedProject,
}: Props): JSX.Element {
  return (
    <>
      {index !== 0 && <SphereDivider sx={{ height: 1 }} />}

      <ListItemCardMobile<SdbMemberTypes>
        item={member}
        image={
          <Stack justifyContent="center">
            <UserAvatarWithMenu member={member} />
          </Stack>
        }
        title={
          <Stack>
            <Text component="var" variant="labelM" sx={{ ...withEllipsis }}>
              {member.email}
            </Text>
            <RoleColumn
              companyId={companyId}
              subjectType={tableSubject}
              isReadOnly
              memberIdentityRole={{
                identity: member.identity,
                role: member.role,
              }}
              group={group}
              selectedProject={selectedProject}
            />
          </Stack>
        }
        href={generateMemberProfileRoute(companyId, member.identity)}
        subtitle={
          member.name ? (
            <Text component="var" variant="bodyM" sx={{ ...withEllipsis }}>
              {member.name}
            </Text>
          ) : (
            <MemberStatus member={member} />
          )
        }
        menuItems={menuItems}
      />
    </>
  );
}
